import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup,FormControl, Validators } from '@angular/forms';
import {Router, ActivatedRoute } from "@angular/router";
import { ReportService } from '../../services/report.service';


@Component({
  selector: 'app-setting',
  templateUrl: './setting.component.html',
  styleUrls: ['./setting.component.scss']
})
export class SettingComponent implements OnInit {
  isCheckeds:any = false;
  acccountValidity:any;
  loginMultipal:any;
  constructor(
    private auth:ReportService,
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private router: Router
  ) { }
  settingForm = new FormGroup({
		 acccountValidity: new FormControl(''),
		 loginMultipal: new FormControl(''),
	});

  ngOnInit(): void {
    this.settingData();
  }
  settingData(){
    this.auth.settingData().subscribe(
      (data)=>{
        this.settingForm.patchValue({
          acccountValidity: data.detail.is_account_valid,
          loginMultipal:data.detail.is_multiple_login_allowed
        });
      },(error)=>{})
  }
//update setting
  onChange($event:any){
    if(this.settingForm.value.acccountValidity==true){
       //this.acccountValidity=1;
       this.loginMultipal=1;
    }else{ 
      //this.acccountValidity=0; 
      this.loginMultipal=0; }

    if(this.settingForm.value.loginMultipal==true){
      // this.loginMultipal=1;
       this.acccountValidity=1;
    }else{  
      //this.loginMultipal=0;
      this.acccountValidity=0; 
    }
    //console.log(this.acccountValidity,this.loginMultipal);
    this.auth.setting(this.acccountValidity,this.loginMultipal).subscribe(
      (data)=>{
       // console.log(data);
      },(error)=>{
       // console.log(error);
      })
    
  }
}
